import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { lastValueFrom } from "rxjs";

import { BrandCampaign } from "../../../shared/models/brandCampaign";
import { cloneWith } from "../../../shared/services/clonable";
import { NotificationService } from "../../../shared/services/notification.service";
import { BrandCampaignService } from "../shared/services/brand-campaign.service";

export type BrandCampaignNameEditDialogData = BrandCampaign;
export type BrandCampaignNameEditDialogResult = BrandCampaign;

@Component({
  templateUrl: "./brand-campaign-name-edit-dialog.component.html",
  styleUrls: ["./brand-campaign-name-edit-dialog.component.scss"],
})
export class BrandCampaignNameEditDialogComponent {
  public saving = false;
  public campaignName: string;

  private campaign: BrandCampaign;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: BrandCampaignNameEditDialogData,
    public dialogRef: MatDialogRef<
      BrandCampaignNameEditDialogComponent,
      BrandCampaignNameEditDialogResult
    >,
    public brandCampaignService: BrandCampaignService,
    public notificationService: NotificationService,
  ) {
    this.campaign = cloneWith(data);
    this.campaignName = this.campaign.name;
  }

  public async updateCampaignName(): Promise<void> {
    this.saving = true;

    try {
      this.campaign.name = this.campaignName;
      this.dialogRef.close(
        await lastValueFrom(
          this.brandCampaignService.updateBrandCampaign(this.campaign),
        ),
      );
    } catch {
      this.notificationService.error("shared.errorSavingChanges");
    } finally {
      this.saving = false;
    }
  }
}
